import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import classes from "./HeFlowConfirmPage.module.css";
import axios from "axios";

const content = {
  en: {
    title: "Confirm Subscription",
    desc: "Please enter the OTP sent to your phone",
    button: "Confirm",
  },
  ar: {
    title: "تأكيد الاشتراك",
    desc: "يرجى إدخال رمز التحقق المرسل إلى هاتفك",
    button: "تأكيد",
  },
};

const HeFlowConfirmPage = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const lang = query.get("lang") === "2" ? "ar" : "en";
  const uniqid = query.get("uniqid"); // MCPuniqid
  const msisdn = query.get("msisdn");

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [antifraudId, setAntifraudId] = useState(null);

  const t = content[lang];


  useEffect(() => {
    document.body.dir = lang === "ar" ? "rtl" : "ltr";

    const fetchPage2 = async () => {
      try {
        const res = await axios.get(
          "http://localhost:3003/api/antifraud",
          {
            params: {
              page: 2,
              ClickID: uniqid,
              msisdn: msisdn,
            },
          }
        );

        if (res.data.success) {
          const antiId = res.data.antifrauduniqid;
          setAntifraudId(antiId);

          if (res.data.script) {
            let scriptTag = document.getElementById("anti-fraud-script");

            if (!scriptTag) {
              scriptTag = document.createElement("script");
              scriptTag.id = "anti-fraud-script";
              document.head.appendChild(scriptTag);
            }

            scriptTag.innerHTML = res.data.script;
          }
        }
      } catch (err) {
        console.error("AntiFraud Page2 Error:", err);
      }
    };

    if (uniqid && msisdn) fetchPage2();
  }, [uniqid, msisdn, lang]);

 
  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").slice(0, 6);
    if (!/^\d+$/.test(pasteData)) return;

    const newOtp = pasteData.split("");
    setOtp(newOtp);

    newOtp.forEach((digit, i) => {
      const input = document.getElementById(`otp-${i}`);
      if (input) input.value = digit;
    });
  };

  const finalOtp = otp.join("");

 
  const handleVerify = async () => {
  if (!antifraudId) {
    alert("AntiFraud not ready yet");
    return;
  }

  if (finalOtp.length !== 6) {
    alert(lang === "ar" ? "ادخل رمز صحيح" : "Enter valid OTP");
    return;
  }

  try {
    const res = await axios.post("/verifyPin", {
      user: "Digitalabs",                 
      password: "DiGit0L02022",         
      msisdn: msisdn,
      shortcode: "2055",       
      serviceId: "22",     
      spId: "3021",               

      LanguageID: lang === "ar" ? 2 : 3, 
      ChannelID: "22800",                

      ClickID: antifraudId,              
      pincode: finalOtp                  
    });

    if (res.data.status === "Success") {
      alert(
        lang === "ar"
          ? "تم الاشتراك بنجاح"
          : "Subscription successful!"
      );
    } else {
      alert(res.data.msg || "Failed");
    }
  } catch (err) {
    console.error("OTP Error:", err);
    alert("Error verifying OTP");
  }
};

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <h2>{t.title}</h2>
        <p>{t.desc}</p>

        
        <div className={classes.otpWrapper} onPaste={handlePaste}>
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-${index}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className={classes.otpInput}
            />
          ))}
        </div>

        <button
          className={`AFsubmitbtn ${classes.button}`}
          onClick={handleVerify}
        >
          {t.button}
        </button>
      </div>
    </div>
  );
};

export default HeFlowConfirmPage;